import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createFlightSelectedEvent } from '@/domain/prices/analytics/index';
import { useFlightSelector } from '@/domain/prices/transports/hooks';
import type { RouteInfo } from '@/domain/prices/transports/types';
import { FlightType } from '@/domain/prices/transports/types';
import * as React from 'react';

export function useSendFlight() {
  const { sendEvent } = useAnalytics();
  const { outboundRoute, inboundRoute } = useFlightSelector();

  const sendOutboundFlightEvent = (flight: RouteInfo | null | undefined) => {
    if (!flight) return;
    sendEvent(createFlightSelectedEvent({ route: flight, type: FlightType.Outbound }));
  };

  const sendInboundFlightEvent = (flight: RouteInfo | null | undefined) => {
    if (!flight) return;
    sendEvent(createFlightSelectedEvent({ route: flight, type: FlightType.Inbound }));
  };

  React.useEffect(() => {
    sendInboundFlightEvent(inboundRoute);
  }, [inboundRoute]);

  React.useEffect(() => {
    sendOutboundFlightEvent(outboundRoute);
  }, [outboundRoute]);
}
